export const fireEvent = (object: any) => {
  // this adds an event object to the gtm datalayer property
  const dataLayer = (window as any)?.dataLayer;
  if (dataLayer?.push && typeof dataLayer.push === 'function') {
    dataLayer.push(object);
  }
};
